import { types } from "../types/types";

const initialState = {
    charging: false,
}


export const modalReducer =(state=initialState, action)=>{
    switch (action.type) {
        case types.modalStartLoadingCliente:
            return{
                ...state,
                charging:true,
            }
        case types.modalFinishLoadingCliente:
            return{
                ...state,
                charging:false,
            }
        case types.modalSetData:
            return {
                ...state,
                ...action.payload,
            }
        case types.modalCleaning:
            return(
                initialState
            )
        default:
            return{
                ...state,
            }
    }
}